module.exports = __webpack_public_path__ + "static/img/_8.09594bec.png";